import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { Layout, Spin } from 'antd';

const { Content } = Layout;

var languageMessages = window.appLocale.messages;

class TdAmeritradePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: false,
            info: '',
            spinLoadding: true,
        };
    }

    componentWillMount() {
        let username = localStorage.getItem("local_user");
        const result = new URLSearchParams(window.location.search);
        const code = result.get('code');
        if (username != null && code != null && code !== undefined) {
            this.props.dispatch({ type: "action_get_code", payload: { u: username, c: code } });
        } else {
            this.setState({ spinLoadding: false });
        }
    }

    componentWillReceiveProps(props) {
        var { status } = props;

        switch (status) {
            case 'get_code_success':
                this.setState({ status: true, spinLoadding: false, info: 'TD Ameritrade account verification succeeded.' });
                break;
            case 'get_code_failed':
                this.setState({ status: false, spinLoadding: false, info: 'TD Ameritrade account verification failed.' });
                break;
            default:
                break;
        }
    }

    render() {
        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
                <div style={{ padding: '50px', margin: '50px', textAlign: 'center', color: this.state.status ? 'green' : 'red', fontSize: 20 }}>
                    {this.state.info}
                </div>
            </Spin>
        </Content>)
    }
}

function mapStateToProps(state) {
    return state.tdAmeritradePage;
}

const page = connect(mapStateToProps)(TdAmeritradePage);

export { page as default }